import { Layer, Source } from 'react-map-gl'
import { coordinateType } from '@commutifi-fe/interfaces'

interface DrawLineProps {
  drawColor?: string
  coordinates: coordinateType[]
}

/**
 * For consistent line drawing across different maps. You can add
 * flexibility to this api when needed. I don't want to add complexity
 * before we need it cause we might never need it
 */
export function DrawLine({ coordinates, drawColor }: DrawLineProps) {
  return (
    <Source
      type="geojson"
      data={{
        type: 'Feature',
        properties: {},
        geometry: { type: 'LineString', coordinates }
      }}
    >
      <Layer
        type="line"
        layout={{ 'line-join': 'round', 'line-cap': 'round' }}
        // Apply legacy blue accent color by default. This can be changed when the Route Planner page map is either removed or refactored.
        // We can default to whatever new design color is the most common for drawing lines.
        paint={{ 'line-color': drawColor || '#1badec', 'line-width': 8 }}
      />
    </Source>
  )
}

DrawLine.propTypes = {}

export default DrawLine
